import {
  UPDATE_PACKAGE,
  PACKAGE_FAILED,
  BEGIN_NEW_PACKAGE,
  RECEIVE_PACKAGE,
  REQUEST_PUSH_PACKAGES,
  RECEIVE_PUSH_PACKAGES,
  PUSH_FAILED,
  CLONE_PACKAGE_FAILED
} from '../actions/types';

export const packageRequest = (state = {}, action) => {
  switch(action.type) {
    case UPDATE_PACKAGE:
      return Object.assign({}, state, {
        isFetching: true,
        package: {},
        error: null
      });
    case RECEIVE_PACKAGE:
      return Object.assign({}, state, {
        isFetching: false,
        package: action.pack,
        error: null
      });
    case PACKAGE_FAILED:
    case CLONE_PACKAGE_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error
      });
    case BEGIN_NEW_PACKAGE:
      return Object.assign({}, state, {
        isFetching: false
      });
    case REQUEST_PUSH_PACKAGES:
      return Object.assign({}, state, {
        isPushing: true,
        pushRequest: action.payload,
        pushResult: {},
        pushError: null
      });
    case RECEIVE_PUSH_PACKAGES:
      return Object.assign({}, state, {
        isPushing: false,
        pushResult: action.payload
      });
    case PUSH_FAILED:
      return Object.assign({}, state, {
        isPushing: false,
        pushError: action.error,
        pushResult: null
      });
    default: {
      return state;
    }
  }
};
